/**
 * Edge is Chromium, so this is not an engine difference — it gates workarounds in the PDF viewer
 * that were only ever reproduced on Edge. Prefer feature detection or a browser-agnostic fallback;
 * reach for this only when the behaviour cannot be detected any other way.
 */
export const IS_EDGE_BROWSER =
  typeof navigator !== 'undefined' && /Edg\//i.test(navigator.userAgent)
